export default function setSearchCreateDateFromAction(searchCreateDateFrom) {
    return {
        type: 'SET_SEARCH_CREATE_DATE_FROM',
        payload: searchCreateDateFrom
    }
}